import { render, staticRenderFns } from "./CreditsHistory.vue?vue&type=template&id=68775178&"
import script from "./CreditsHistory.vue?vue&type=script&lang=js&"
export * from "./CreditsHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports